window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html: $('html'),
    $body: $('body'),

    // Navigation
    $navigation: $('#accessibleNav'),

    // Product Page
    $mainImage: $('#productPhotoImg'),
    $thumbImages: $('#productThumbs').find('a.product-photo-thumb'),
    newImage: null
  }
}

timber.init = function () {
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.productImageSwitch();
  timber.shuffleImages();
  timber.productImagePopup();

  
  timber.modal();
  
}

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav--dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul');
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav--dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if ( !isSubItem ) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
}

timber.productImageSwitch = function () {
  if ( !timber.cache.$thumbImages.length ) {
    return;
  }

  // Switch the main image with one of the thumbnails
  // Note: this does not change the variant selected, just the image
  timber.cache.$thumbImages.on('click', function(e) {
    e.preventDefault();
    timber.cache.newImage = $(this).attr('href');
    timber.cache.$mainImage.attr({ src: timber.cache.newImage });
  });
}

timber.productImagePopup = function () {
  $('.product__images a img').parent().magnificPopup({
      type: 'image',
      zoom: {
        enabled: true,
        duration: 300, // don't foget to change the duration also in CSS
        opener: function(element) {
            return element.find('img');
        }
      },
      callbacks: {
        open: function() {
          $(this.currItem.el).find('img').css('visibility', 'hidden');
        },
        close: function() {
          $(this.currItem.el).find('img').css('visibility', 'visible');
        }
      }
  });
}

timber.modal = function () {
  if ($.cookie('modal_displayed')) {
    // Modal already displayed, don't do anything
  } else {
    var $modal = $('#modal');
    var $modalEl = $('#modal').find('.modal');

    $.cookie('modal_displayed', true, { expires: 1, path: '/' });
    
    $modal.find('.modal__close').on('click', function() {
      $modal.removeClass('visible');
    });

    $modal.on('click', function(e) {
      if($modalEl.has(e.target).length === 0){
        $modal.removeClass('visible');
      }
    });

    $modal.addClass('visible');
  }
}

timber.shuffleImages = function () {
  $('.product--list .product-grid-image').each(function() {
    var mouseOffset = $(this).width() / $(this).find('img').length;
    $(this).shuffleImages({
      mouseMoveTrigger: mouseOffset
    });
  });
}


// Initialize Timber's JS on docready
$(timber.init)
